import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/diet-settings/biometric/',
    redirectTo: '/diet-settings/biometric/sex',
  },
];

export default redirects;
